import React from 'react';
import { Phone, Zap, CheckCircle, Wrench, Shield, MapPin } from 'lucide-react';
export function TeslaCybertruckPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-8417">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-8418">
        <div className="container mx-auto px-4" data-id="element-8419">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-8420">
            Tesla Cybertruck Maintenance
          </h1>
          <p className="text-xl text-gray-100" data-id="element-8421">
            Expert Service for Modern Electric Vehicles
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-8422">
        <div className="max-w-4xl mx-auto" data-id="element-8423">
          {/* Hero Image */}
          <div className="mb-8" data-id="element-8424">
            <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Tesla/Cyber-Truck-Service/Depiction%20of%20Tesla%20Cyber%20Truck%20on%20Woodward%20Ave%20in%20Birmingham%20MI%20Image%20Sep%204%2C%202025%2C%2004_22_25%20PM.png?opt=w3" alt="Tesla Cybertruck on Woodward Ave in Birmingham MI" className="w-full h-auto rounded-lg shadow-md" data-id="element-8425" />
          </div>

          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8426">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-8427">
              Tesla Cybertruck Maintenance You Can Trust
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-8428">
              The <strong data-id="element-8429">Tesla Cybertruck</strong> is one of the most advanced
              vehicles ever built—bold in design, powerful in performance, and
              engineered with cutting-edge electric technology. At{' '}
              <strong data-id="element-8430">Garrett Auto & Truck Service</strong>, we specialize in{' '}
              <strong data-id="element-8431">Cybertruck maintenance and repair</strong>, helping Tesla
              owners keep their trucks running at peak performance.
            </p>

            <div className="text-center mb-6" data-id="element-8432">
              <a href="tel:+12484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-8433">
                <Phone className="mr-3" size={24} data-id="element-8434" />
                Call 248-478-8382 Now to Schedule Your Service
              </a>
            </div>

            <p className="text-gray-700" data-id="element-8435">
              If you're searching for{' '}
              <strong data-id="element-8436">"Tesla Cybertruck maintenance near me"</strong> or{' '}
              <strong data-id="element-8437">"Cybertruck repair near me,"</strong> you've found the
              trusted local shop ready to handle all your service needs.
            </p>
          </div>

          {/* Why Choose Us */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8438">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-8439">
              Why Bring Your Cybertruck to Garrett Auto & Truck Service?
            </h2>

            <ul className="space-y-4" data-id="element-8440">
              <li className="flex items-start" data-id="element-8441">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8442" />
                <div data-id="element-8443">
                  <strong className="text-gray-900" data-id="element-8444">
                    Full-Service Tesla Cybertruck Care
                  </strong>
                  <p className="text-gray-700" data-id="element-8445">
                    Routine maintenance – we're your one-stop shop.
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-8446">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8447" />
                <div data-id="element-8448">
                  <strong className="text-gray-900" data-id="element-8449">
                    Faster, Local Service
                  </strong>
                  <p className="text-gray-700" data-id="element-8450">
                    Avoid long waits at Tesla service centers. Get your{' '}
                    <strong data-id="element-8451">Cybertruck serviced locally</strong> with expert
                    care and personal attention.
                  </p>
                </div>
              </li>
            </ul>
          </div>

          {/* Services Offered */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8452">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-8453">
              Tesla Cybertruck Maintenance Services We Offer
            </h2>

            <p className="text-gray-700 mb-6" data-id="element-8454">
              Our team is fully equipped to handle every aspect of{' '}
              <strong data-id="element-8455">Cybertruck service and repair</strong>, including:
            </p>

            <ul className="space-y-3 mb-6" data-id="element-8456">
              <li className="flex items-start" data-id="element-8457">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8458" />
                <span className="text-gray-700" data-id="element-8459">
                  <strong data-id="element-8460">Cybertruck Battery Health Checks</strong> & cooling
                  system service
                </span>
              </li>
              <li className="flex items-start" data-id="element-8461">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8462" />
                <span className="text-gray-700" data-id="element-8463">
                  <strong data-id="element-8464">Tesla Tire Service</strong> – rotations, balancing &
                  replacement for Cybertruck tires
                </span>
              </li>
              <li className="flex items-start" data-id="element-8465">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8466" />
                <span className="text-gray-700" data-id="element-8467">
                  <strong data-id="element-8468">Cybertruck Brake Service</strong> – inspections,
                  repairs & regenerative brake system support
                </span>
              </li>
              <li className="flex items-start" data-id="element-8469">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8470" />
                <span className="text-gray-700" data-id="element-8471">
                  <strong data-id="element-8472">Tesla Cybertruck Cabin Air Filter Replacement</strong>
                </span>
              </li>
              <li className="flex items-start" data-id="element-8473">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8474" />
                <span className="text-gray-700" data-id="element-8475">
                  <strong data-id="element-8476">
                    Preventative Maintenance & General Inspections
                  </strong>
                </span>
              </li>
            </ul>

            <p className="text-gray-700" data-id="element-8477">
              When it comes to <strong data-id="element-8478">Cybertruck maintenance near me</strong>,
              no one delivers better service than Garrett Auto & Truck Service.
            </p>
          </div>

          {/* Collision & Body Repairs */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8479">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-8480">
              Tesla Cybertruck Collision & Body Repairs
            </h2>

            <p className="text-gray-700 mb-4" data-id="element-8481">
              The Cybertruck's stainless steel exoskeleton is built for
              strength, but damage can still happen. Our team provides{' '}
              <strong data-id="element-8482">Tesla Cybertruck collision repair and bodywork</strong>,
              restoring both appearance and performance. From stainless steel
              dent repair to accident restoration, we have the tools and
              experience to bring your Cybertruck back to like-new condition.
            </p>
          </div>

          {/* Premier Service Center Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8483">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-8484">
              Your Premier Cybertruck Service Center
            </h2>
            <h3 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-8485">
              Garrett Auto and Truck Service
            </h3>

            <p className="text-gray-700 mb-6" data-id="element-8486">
              Looking for{' '}
              <strong data-id="element-8487">
                certified Tesla Cybertruck maintenance in Farmington Hills,
                Michigan
              </strong>
              ? Trust the experts at Garrett Auto and Truck Service—your #1
              destination for cutting-edge electric truck care. Our technicians
              stay at the forefront of Tesla technology, delivering flawless
              service, repairs, and performance upgrades for Cybertruck owners
              across Oakland and Wayne Counties. Whether you need routine
              checkups or complex diagnostics, we're the authority you can count
              on!
            </p>

            <div className="bg-blue-50 rounded-lg p-6 mb-6" data-id="element-8488">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-8489">
                <MapPin className="mr-2 text-[#B1050B]" size={24} data-id="element-8490" />
                Proudly Serving Cybertruck Owners in:
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-8491">
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8492">
                  Novi
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8493">
                  Northville
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8494">
                  Livonia
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8495">
                  West Bloomfield
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8496">
                  Southfield
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8497">
                  Bloomfield Hills
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8498">
                  Wixom
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8499">
                  Franklin
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8500">
                  Bingham Farms
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8501">
                  Beverly Hills
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8502">
                  Plymouth
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8503">
                  Orchard Lake
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8504">
                  Lathrup Village
                </span>
                <span className="bg-white px-4 py-2 rounded-lg text-gray-800 font-semibold shadow-sm" data-id="element-8505">
                  Redford
                </span>
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-8506">
              Why Choose Us for Your Tesla Cybertruck?
            </h3>
            <ul className="space-y-3 mb-6" data-id="element-8507">
              <li className="flex items-start" data-id="element-8508">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8509" />
                <div data-id="element-8510">
                  <strong className="text-gray-900" data-id="element-8511">
                    Tesla-Certified Technicians:
                  </strong>
                  <span className="text-gray-700" data-id="element-8512">
                    {' '}
                    We use the latest Cybertruck documentation and genuine parts
                    for superior results.
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-8513">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8514" />
                <div data-id="element-8515">
                  <strong className="text-gray-900" data-id="element-8516">
                    Comprehensive Maintenance:
                  </strong>
                  <span className="text-gray-700" data-id="element-8517">
                    {' '}
                    Tire rotations, brake fluid checks, HEPA filter changes,
                    brake caliper lubrication, A/C service, Gigawiper blade
                    care, and more.
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-8518">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8519" />
                <div data-id="element-8520">
                  <strong className="text-gray-900" data-id="element-8521">EV Specialists:</strong>
                  <span className="text-gray-700" data-id="element-8522">
                    {' '}
                    Safe procedures for high-voltage systems, powertrain,
                    Autopilot/FSD calibration, and digital diagnostics.
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-8523">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8524" />
                <div data-id="element-8525">
                  <strong className="text-gray-900" data-id="element-8526">
                    Customer-First Approach:
                  </strong>
                  <span className="text-gray-700" data-id="element-8527">
                    {' '}
                    Easy scheduling, local shuttle service, and transparent
                    pricing—never any surprises.
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-8528">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-8529" />
                <div data-id="element-8530">
                  <strong className="text-gray-900" data-id="element-8531">Proven Reputation:</strong>
                  <span className="text-gray-700" data-id="element-8532">
                    {' '}
                    Trusted by Tesla drivers from Farmington Hills and all
                    neighboring communities within 15 miles!
                  </span>
                </div>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-8533">
              Official Tesla Cybertruck Maintenance Schedule
            </h3>
            <div className="overflow-x-auto" data-id="element-8534">
              <table className="w-full border-collapse border border-gray-300" data-id="element-8535">
                <thead data-id="element-8536">
                  <tr className="bg-gray-100" data-id="element-8537">
                    <th className="border border-gray-300 px-4 py-3 text-left font-bold text-gray-900" data-id="element-8538">
                      Service Item
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left font-bold text-gray-900" data-id="element-8539">
                      Interval/Requirement
                    </th>
                    <th className="border border-gray-300 px-4 py-3 text-left font-bold text-gray-900" data-id="element-8540">
                      Details
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-8541">
                  <tr data-id="element-8542">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8543">
                      Tire Rotation
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8544">
                      6,250 miles or 1 year
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8545">
                      Critical for even wear and range
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-8546">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8547">
                      Brake Fluid Check
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8548">
                      Every 4 years
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8549">
                      Replace if needed or with heavy use
                    </td>
                  </tr>
                  <tr data-id="element-8550">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8551">
                      HEPA Cabin Air Filter
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8552">
                      Every 2 years
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8553">
                      Annually if off-roading or urban
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-8554">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8555">
                      A/C Desiccant Bag
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8556">
                      Every 8 years
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8557">
                      Protects air conditioning system
                    </td>
                  </tr>
                  <tr data-id="element-8558">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8559">
                      Brake Caliper Service
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8560">
                      Every 12,500 miles/annually in snowy areas
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8561">
                      Prevents road salt corrosion
                    </td>
                  </tr>
                  <tr className="bg-gray-50" data-id="element-8562">
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8563">
                      Wiper Blades and Fluid
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8564">
                      As needed
                    </td>
                    <td className="border border-gray-300 px-4 py-3 text-gray-700" data-id="element-8565">
                      OEM Gigawiper service available
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mt-6" data-id="element-8566">
              <p className="text-sm text-gray-700" data-id="element-8567">
                <strong data-id="element-8568">Official Schedule:</strong> All maintenance intervals
                based on current Tesla Cybertruck Service Manual documentation
                and certified EV repair protocols (
                <em data-id="element-8569">updated September 2025</em>).
              </p>
            </div>
          </div>

          {/* Final CTA */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-8570">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-8571">
              Keep Your Tesla Cybertruck Running Strong
            </h2>
            <p className="text-gray-700 mb-6" data-id="element-8572">
              Your Tesla Cybertruck is more than a truck—it's an investment in
              the future. Protect that investment with expert{' '}
              <strong data-id="element-8573">Tesla Cybertruck maintenance and repair</strong> from
              Garrett Auto & Truck Service.
            </p>
            <p className="text-gray-700" data-id="element-8574">
              Don't wait until minor issues become major headaches. Garrett Auto
              and Truck Service delivers world-class{' '}
              <strong data-id="element-8575">Tesla Cybertruck maintenance</strong> right here in
              Farmington Hills. Join Cybertruck drivers from Novi, Northville,
              Livonia, West Bloomfield, Southfield, Bloomfield Hills, and all
              the vibrant communities nearby—who trust us with their advanced
              electric trucks.
            </p>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-8576">
            <h2 className="text-3xl font-bold mb-4" data-id="element-8577">
              Schedule Your Tesla Cybertruck Maintenance TODAY!
            </h2>
            <p className="text-xl mb-6" data-id="element-8578">
              <strong data-id="element-8579">
                Call us today to schedule your Cybertruck service appointment
                and experience the difference of expert local care.
              </strong>
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-8580">
              <Phone className="mr-3" size={24} data-id="element-8581" />
              Book Your Cybertruck Service Now - Call 248-478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-8582">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}